<template>
  <div class="md-layout p-0">
    <div class="md-layout-item md-size-20 pt-[6px] p-0">
      <md-checkbox :value="value" v-model="recSetting">{{
        $t(label)
      }}</md-checkbox>
    </div>
    <div
      class="md-layout-item md-size-30 -mb-2"
      v-if="recSetting && recSetting !== 'other_staffs'"
    >
      <md-field>
        <label>{{ $t("communication.filter_by") }}</label>
        <md-select v-model="recipientFilter.filter">
          <md-option
            v-for="option in filterList"
            :value="option.id"
            :key="option.id + option.name"
            >{{ $t(option.name) }}
          </md-option>
        </md-select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-30 relative" v-if="multiRecipient">
      <validation-field
        :validations="{ required: true }"
        :name="nameResRequire"
        type="multi-select"
        style="margin-bottom: 0px !important"
        :key="recComponentKey"
      >
        <template #default="{ errors }">
          <CheckboxMultiSelect
            :label="labelRec"
            :options="optionRecSelected"
            :trackBy="trackByRec"
            v-model="recipientFilter.filter_id"
            @filtering="filteringOpts($event.text)"
            @select="selectItem"
            @open="openOpts"
            @removed="removedItem"
          >
          </CheckboxMultiSelect>
          <span class="md-error">{{ errors[0] }}</span>
        </template>
      </validation-field>
    </div>
    <div class="md-layout-item md-size-20 pt-[6px]" v-if="statusRecipient">
      <md-checkbox
        v-model="recipientFilter.status"
        :class="{
          'justify-end w-full': styleActiveStatus
        }"
        >{{ $t("survey.active_status") }}</md-checkbox
      >
    </div>
  </div>
</template>

<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { dataRecipient } from "./Recipient.js";
import { API_RECIPIENT, LIST_RECIPIENT, API_DEBOUNCE } from "./index.js";
import { service_paths } from "@/constants/Services";

const recSettingDefault = () => ({
  filter: "all",
  filter_id: [],
  status: false
});
const path = service_paths;
export default {
  props: [
    "label",
    "value",
    "filterList",
    "recipientFilterProps",
    "settingProps"
  ],
  components: { CheckboxMultiSelect },
  mixins: [dataRecipient],
  data() {
    return {
      API_DEBOUNCE,
      key: null,
      nameResRequire: null,
      recComponentKey: null,
      labelRec: null,
      trackByRec: null,
      optionRecSelected: [],
      recSetting: null,
      recipientFilter: recSettingDefault()
    };
  },
  created() {
    if (this.recipientFilterProps) {
      this.recipientFilter = this.recipientFilterProps;
      this.recSetting = this.settingProps;
    }
  },
  watch: {
    recSetting: function(recSetting) {
      this.$emit("checkRecipient", recSetting);
      if (recSetting !== "other_staffs" && recSetting === null) {
        this.optionSelected[LIST_RECIPIENT[this.recipientFilter.filter]] = [];
        this.recipientFilter = recSettingDefault();
        this.optionRecSelected = [];
      }
      if (recSetting === "other_staffs") {
        this.recComponentKey++;
        this.labelRec = "sidebar.role";
        this.nameResRequire = "other staffs";
        this.debounceSearchKey(
          event,
          { "name__~": "", limit: 20 },
          `${path.staffs}/roles`
        );
      }
    },
    "recipientFilter.filter": function(filter) {
      this.selectRecipient(filter);
    }
  },
  computed: {
    statusRecipient() {
      return (
        this.recSetting &&
        this.recipientFilter.filter !== "student" &&
        this.recipientFilter.filter !== "parent" &&
        this.recipientFilter.filter !== "teacher"
      );
    },
    multiRecipient() {
      return (
        (this.recSetting && this.recipientFilter.filter !== "all") ||
        this.recSetting === "other_staffs"
      );
    },
    styleActiveStatus() {
      return (
        this.recSetting !== "other_staffs" &&
        this.recipientFilter.filter !== "all"
      );
    }
  },
  methods: {
    openOpts(event) {
      eval(API_DEBOUNCE[this.recipientFilter.filter]);
    },
    selectItem(event) {
      this.optionSelected[LIST_RECIPIENT[this.recipientFilter.filter]].push(
        event.itemData
      );
    },
    removedItem(event) {
      this.optionSelected[
        LIST_RECIPIENT[this.recipientFilter.filter]
      ] = this.optionSelected[
        LIST_RECIPIENT[this.recipientFilter.filter]
      ].filter(item => {
        return this.recipientFilter.filter === "grade"
          ? item.name !== event.itemData?.name
          : item.id !== event.itemData?.id;
      });
    },
    filteringOpts(event) {
      if (this.recSetting === "other_staffs") {
        this.debounceSearchKey(
          event,
          { "name__~": event, limit: 20 },
          `${path.staffs}/roles`
        );
      }
      eval(API_DEBOUNCE[this.recipientFilter.filter]);
    },
    selectRecipient(recipiented) {
      if (this.recSetting !== "other_staffs") {
        this.recipientFilter.filter_id = [];
        this.optionSelected[LIST_RECIPIENT[this.recipientFilter.filter]] = [];
        this.optionRecSelected = [];
      }
      this.recComponentKey++;
      this.trackByRec = "id";
      switch (recipiented) {
        case "class":
          this.labelRec = "common.class";
          this.nameResRequire = `class of ${this.recSetting}`;
          break;
        case "term":
          this.labelRec = "common.term";
          this.nameResRequire = `term of ${this.recSetting}`;
          break;
        case "grade":
          this.labelRec = "common.grade";
          this.nameResRequire = `grade of ${this.recSetting}`;
          this.trackByRec = "name";
          break;
        case "program":
          this.labelRec = "common.program";
          this.nameResRequire = `program of ${this.recSetting}`;
          break;
        case "student":
          this.labelRec = "common.student";
          this.nameResRequire = `student name of ${this.recSetting}`;
          break;
        case "parent":
          this.labelRec = "survey.parent_info";
          this.nameResRequire = `parent name of ${this.recSetting}`;
          break;
        case "teacher":
          this.labelRec = "survey.teacher_info";
          this.nameResRequire = `teacher name of ${this.recSetting}`;
          break;
        case "all":
          this.recipientFilter.filter_id = [];
          break;
        default:
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-checkbox {
  display: flex;
}
.md-checkbox {
  width: 300px;
}
.checkbox-name {
  color: gray;
  font-size: 16px;
  width: 170px;
}
.md-input {
  width: 220px;
}
.from-submit {
  display: flex;
  justify-content: center;
}
.md-error {
  position: absolute;
  color: var(--md-theme-default-fieldvariant, #ff1744);
  font-size: 12px;
}
.md-title {
  font-size: 18px;
}
.hidden-tooltip {
  display: none;
}
.md-tooltip {
  overflow-wrap: break-word;
}
.required:after {
  content: " *";
  color: red;
}
::v-deep .checkbox-multi-selections label {
  display: block;
  margin: -3px 0;
  color: #aaa;
  font-weight: 400;
}
</style>
